import React, { FC } from "react";
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { Typeahead } from "react-bootstrap-typeahead";
import { InputChangeEvent } from "./types";
import { FilterLabels, FilterName } from "../../../../context/teamQ/reducers/filtersReducer";
import { useTeamQContext } from "../../../../context/teamQContextProvider";
import { convertToSelectOptions, IdLabelDictionary } from "../../../../models/staticData";
import { SelectOption } from "../../../../models/selectOption";

interface Props {
  canHide: boolean;
  filterName: FilterName;
  handleFilter: (event: InputChangeEvent) => void;
  handleHide: (name: FilterName) => void;
  options: IdLabelDictionary;
  multiple?: boolean;
}

export const SelectInput: FC<Props> = ({ canHide, filterName, handleFilter, handleHide, multiple = false, options }) => {

  const {
    state: { filters },
  } = useTeamQContext();
  
  const filter = filters[filterName];

  if (!filter.show) return null;
  
  return (
    <div className="form-group">
      <label htmlFor={filterName}>{FilterLabels[filterName]}</label>
      <div className="row">
        {canHide && 
          <div
            className="col-2 pl-2 pt-2"
            role="button"
            aria-label="Hide filter"
          >
            <ClearOutlinedIcon
              role="button"
              aria-label={`Hide ${FilterLabels[filterName]} filter`}
              onClick={()=>handleHide(filterName)} 
          /> 
        </div>}
        <FormControl className={canHide ? "col-9": "col-11 pl-3"}>
          {multiple ? (
            <Typeahead
              id={filterName}
              multiple
              positionFixed
              placeholder={`Select ${FilterLabels[filterName]}`}
              onChange={(selected: SelectOption[]): void => handleFilter({
                target: {
                  name: filterName,
                  value: selected.map((item) => item.id).join(";"),
                },
              } as InputChangeEvent)}
              selected={convertToSelectOptions(options).filter((item) =>{
                if (typeof filter.value === "number") { // legacy filter saved before this release
                  return filter.value === item.id;
                }
                return filter.value.split(";").filter(Boolean).map(Number).includes(item.id);
              })}
              options={convertToSelectOptions(options)}
            />
          ) : (
            <Select
              id={filterName}
              labelId={`${filterName}-label`}
              displayEmpty
              disableUnderline
              name={filterName}
              onChange={(e): void => handleFilter(e as InputChangeEvent)}
              value={filter.value}
            >
              <MenuItem value="">Select one</MenuItem>

              {convertToSelectOptions(options).map((item, index: number) => (
                <MenuItem key={index} value={item.id}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </div>
    </div>
  );
};
